//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = {
    card: {
        maxWidth: 400,
        height: 350
    },
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: 'cover',
    },
};


//'url(' + require('../../images/IMG_1.JPG')
class InsuranceCard extends React.Component {

            constructor(props) {
                super(props);

            }

            render() {
            const {classes} = this.props;
            return (
                < Card
            className = {classes.card} elevation={20} >
                < CardActionArea >
                < CardMedia
            component = "img"
            alt = "Saving Money"
            className = {classes.media}
            height = "140"
            image = { '/static/images/insurance3.jpg'}
            title = "Liability Damage"
                / >
                < CardContent >
                < Typography
              gutterBottom
            variant = "h5"
            component = "h2" >
                Damage & Insurance
                < /Typography>
                < Typography
            component = "p" >
              Every time your vehicle gets towed, you increase the chance of damaging your vehicle.
            < /Typography>
            < /CardContent>
            < /CardActionArea>
              {/*}
            < CardActions >
            < Button
            size = "small"
            color = "primary" >
                Share
                < /Button>
                < Button
            size = "small"
            color = "primary"  href="#aboutplatewiz">
                Learn
            More
            < /Button>
            < /CardActions> */}
            < /Card>
        )
            ;
        }//end of render
}//End of class

InsuranceCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(InsuranceCard);